var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgFolder = function SvgFolder(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0D2976",
    d: "M17.5 6.625v8.678c0 .799-.63 1.447-1.406 1.447H3.906c-.776 0-1.406-.649-1.406-1.447V4.696c0-.797.63-1.446 1.406-1.446h4.688l1.875 1.928h5.625c.776 0 1.406.648 1.406 1.447"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFolder);
export default ForwardRef;